'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

exports.default = Title;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCoords2 = require('./helpers/getCoords');

var _getCoords3 = _interopRequireDefault(_getCoords2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders title (text or everything else) at specified `position`.
 *
 * @example ../docs/examples/Title.md
 */
function Title(props) {
    var style = props.style,
        className = props.className,
        children = props.children;

    var _getCoords = (0, _getCoords3.default)(props.position, props.layerWidth, props.layerHeight, props.width, props.height),
        x = _getCoords.x,
        y = _getCoords.y;

    return _react2.default.createElement(
        'g',
        {
            className: className,
            transform: 'translate(' + x + ' ' + y + ')',
            style: style },
        (0, _isString3.default)(children) ? _react2.default.createElement(
            'text',
            null,
            children
        ) : (0, _isFunction3.default)(children) ? children(props) : children
    );
}

Title.displayName = 'Title';

Title.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,

    width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    position: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),

    children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string, _propTypes2.default.node]).isRequired,
    layerWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    layerHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    series: _propTypes2.default.array
};

Title.defaultProps = {
    position: 'top center'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/Title.js
// module id = 1461
// module chunks = 0